import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { hearAboutList, sendForgetPasswordMail, setPassword } from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { useSelector } from "react-redux";

const validationSchema = Yup.object({
    referralSource: Yup.string().required("required"),
  });

export default function ReferralSource() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const listOfHearList = useSelector((e) => e.userAuth.hearAboutData)

    useEffect(() => {
        dispatch(hearAboutList())
    }, [])

    const handleSubmit = (values) => {
        let password = sessionStorage.getItem("password")
        // dispatch(startstopLoading(true));
        if (values.referralSource) {
            dispatch(setPassword({ id: id, password: password, hearAboutUs: values.referralSource })).then((res) => {
                if (res?.payload?.statusCode === 200) {
                    navigate("/");
                    toast.success("Password updated successfully.");
                } else {
                    toast.error(res?.payload?.message || "Failed to update password.");
                }
            });
        }
    };

    return (
      <div className="p-3">
        <Container fluid>
          <div className="row sign-banner-part">
            <Col lg={6} className="p-0">
              <div className="otp-banner-img"></div>
            </Col>
            <Col lg={6}>
              <div className="right-banner-part">
                <div className="login-cmn-box">
                  <div className="login-box-inner-wrap">
                    <div className="login-logo">
                      <img
                        src={require("../Assets/Images/dark-logo.png")}
                        alt="Logo"
                      />
                    </div>
                    <h2>Referral Source</h2>
                    <p className="mb-0"></p>

                    <Formik
                      initialValues={{ referralSource: "" }}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                          <div className="form-set">
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicReferral"
                            >
                              <Form.Label>
                                Where did you hear about us?
                              </Form.Label>
                              <Field
                                as="select"
                                name="referralSource"
                                className="form-select"
                                id="category"
                              >
                                <option value="">
                                  Select a referral source
                                </option>
                                {listOfHearList?.map((item) => (
                                  <option key={item?._id} value={item?._id}>
                                    {item?.name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="referralSource"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </div>

                          <button type="submit" className="submit forgot-btn">
                            Submit
                          </button>
                        </FormikForm>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </Container>
      </div>
    );
}
